import React from "react";
import "./VlogDetails.css";

const VlogDetails = ({ vlogDetails }) => {
  return (
    <>
      <div>
        <h1
          className={`mb-3 card-VlogTitle ${
            vlogDetails.NumberVlog ? "text-start" : ""
          }`}
        >
          {vlogDetails.VlogTitle}
        </h1>
      </div>

      <div className="d-md-flex flex-column flex-md-row">
        {vlogDetails.NumberVlog && (
          <p className="card-subtitle mb-2 mb-md-0">
            באתר LeetCode מספר השאלה : {vlogDetails.NumberVlog}
          </p>
        )}
        <div className="d-none d-md-block flex-fill"></div>
        <p className="card-subtitle">
          פורסם בתאריך : {vlogDetails.PublishedOn}
        </p>
      </div>
    </>
  );
};

export default VlogDetails;
